export const environment = {
  production: true,
  libraryId: '0183300',
  apiRoot: 'https://depotbiblioteket.no/r/jatakk/1.0',
  version: '2.0.0-138',
  sendToSentry: true,
  env: 'prod',
};
